"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Checkbox_1 = __importDefault(require("material-ui/Checkbox"));
var muiThemeable_1 = __importDefault(require("material-ui/styles/muiThemeable"));
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var reduxFormWrappers_1 = require("./reduxFormWrappers");
var check_box_outline_blank_1 = __importDefault(require("material-ui/svg-icons/toggle/check-box-outline-blank"));
var check_box_1 = __importDefault(require("material-ui/svg-icons/toggle/check-box"));
var styleOverride = {
    display: 'inline-block',
    verticalAlign: 'bottom',
    width: 'auto',
    height: 48,
};
var iconStyle = {
    alignSelf: 'center',
};
var errorStyle = function (color) { return ({
    position: 'relative',
    bottom: -6,
    fontSize: 12,
    lineHeight: '12px',
    marginLeft: -40,
    color: color,
    borderTop: 'solid 2px ' + color,
}); };
var UasCheckbox = function (_a) {
    var errorText = _a.errorText, uncheckColor = _a.uncheckColor, checkColor = _a.checkColor, muiTheme = _a.muiTheme, style = _a.style, checkboxStyle = _a.checkboxStyle, className = _a.className, mandatory = _a.mandatory, rest = __rest(_a, ["errorText", "uncheckColor", "checkColor", "muiTheme", "style", "checkboxStyle", "className", "mandatory"]);
    var errorColor = muiTheme.textField.errorColor;
    var checkStyle = __assign({}, styleOverride, checkboxStyle);
    var emptyStyle = uncheckColor ? { fill: uncheckColor } : undefined;
    var filledStyle = checkColor ? { fill: checkColor } : undefined;
    // const errorStyle2 = { fill: errorColor };
    return (react_1.default.createElement("span", { style: style, className: className },
        react_1.default.createElement(Checkbox_1.default, __assign({ checkedIcon: react_1.default.createElement(check_box_1.default, { style: filledStyle }), 
            // uncheckedIcon={<UnChecked style={mandatory ? errorStyle2 : emptyStyle} />}
            uncheckedIcon: react_1.default.createElement(check_box_outline_blank_1.default, { style: emptyStyle }), iconStyle: iconStyle, color: "green", style: checkStyle }, rest)),
        !lodash_1.isEmpty(errorText) && react_1.default.createElement("span", { style: errorStyle(errorColor) }, errorText)));
};
var ComposedUasCheckbox = recompose_1.compose(recompose_1.pure, recompose_1.defaultProps({ value: false, onChange: lodash_1.noop, checkboxStyle: {} }), muiThemeable_1.default(), recompose_1.renameProp('value', 'checked'), recompose_1.withHandlers({
    onCheck: function (_a) {
        var onChange = _a.onChange;
        return function (event, checked) { return onChange(checked); };
    },
}))(UasCheckbox);
exports.default = ComposedUasCheckbox;
exports.FormCheckbox = reduxFormWrappers_1.booleanWrapper(ComposedUasCheckbox);
//# sourceMappingURL=Checkbox.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Checkbox.js
// module id = 368
// module chunks = 0